import type { PortalBootstrapData } from './types/window';
import type { IntegrationApi } from './connectionTypes';
import { __ } from '@/hub-shared/utils/i18n';
import OAuth2Wizard from './wizards/OAuth2Wizard';
import ApiKeyWizard from './wizards/ApiKeyWizard';
import ComptExpertTokenWizard from './wizards/ComptExpertTokenWizard';

type ConnectionWizardProps = {
  bootstrap: PortalBootstrapData;
  api: IntegrationApi;
  onClose: () => void;
  onConnectionUpdated: () => void;
  onSessionExpired: () => void;
};

const ConnectionWizard = ({ bootstrap, api, onClose, onConnectionUpdated, onSessionExpired }: ConnectionWizardProps) => {
  const commonProps = {
    restBasePath: api.restBasePath,
    nonce: bootstrap.nonce,
    apiBaseUrl: bootstrap.restUrls.accountingHub,
    onClose,
    onConnectionUpdated,
    onSessionExpired,
  };

  return (
    <div className="connection-wizard-backdrop" role="presentation">
      <section className="connection-wizard-modal container-style" role="dialog" aria-modal="true" aria-label={api.name}>
        <header className="connection-wizard-header">
          <h3>{api.name}</h3>
          <button type="button" className="btn-secondary" onClick={onClose}>
            {__('Fermer')}
          </button>
        </header>
        {api.authType === 'oauth2' ? <OAuth2Wizard {...commonProps} connected={api.connected} /> : null}
        {api.authType === 'comptexpert' ? <ComptExpertTokenWizard {...commonProps} connected={api.connected} /> : null}
        {api.authType === 'api_key' ? <ApiKeyWizard {...commonProps} connected={api.connected} /> : null}
        {api.authType !== 'oauth2' && api.authType !== 'comptexpert' && api.authType !== 'api_key' ? (
          <p>{__("Ce type de connexion n'est pas encore disponible.")}</p>
        ) : null}
      </section>
    </div>
  );
};

export default ConnectionWizard;
